import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <p>© 2026 Movie Database Interface | Built with React</p>
    </footer>
  );
};

export default Footer;